import { render, staticRenderFns } from "./unknownIdentity.vue?vue&type=template&id=b10ceaca&scoped=true"
import script from "./unknownIdentity.vue?vue&type=script&lang=js"
export * from "./unknownIdentity.vue?vue&type=script&lang=js"
import style0 from "./unknownIdentity.vue?vue&type=style&index=0&id=b10ceaca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10ceaca",
  null
  
)

export default component.exports